import gmdss from '../Assets/images/gmdss.jpg';
import vhf from '../Assets/images/vhf.jpg';
import mfhf from '../Assets/images/mfhf.jpg';
import inmarsat from '../Assets/images/inmarsat.jpg';
import iridium from '../Assets/images/iridium.jpg';

const comProducts = [
    {
      id: 1,
      name: "GMDSS System",
      description: "Global Maritime Distress and Safety System - Complete integrated communication safety system",
      image: gmdss,
      features: [
        "Integrated distress alert system",
        "Maritime safety information reception",
        "Search and rescue coordination",
        "Emergency position indication"
      ],
      specifications: [
        { name: "Coverage", value: "Global" },
        { name: "Power Supply", value: "110/220V AC & 24V DC" },
        { name: "Operating Temperature", value: "-15°C to +55°C" },
        { name: "Compliance", value: "IMO SOLAS regulations" }
      ]
    },
    {
      id: 2,
      name: "Marine VHF Radio",
      description: "Very High Frequency radio communication system for short-range maritime communications",
      image: vhf,
      features: [
        "Digital Selective Calling (DSC)",
        "Waterproof design (IPX7)",
        "Dual and tri-watch operation",
        "Built-in GPS receiver"
      ],
      specifications: [
        { name: "Frequency Range", value: "156-174 MHz" },
        { name: "Output Power", value: "25W/1W" },
        { name: "Channels", value: "All international marine channels" },
        { name: "Battery Life", value: "12 hours typical use" }
      ]
    },
    {
      id: 3,
      name: "MF/HF Radio System",
      description: "Medium and High Frequency radio system for long-range maritime communications",
      image: mfhf,
      features: [
        "SSB and DSC operation",
        "Integrated antenna tuner",
        "Remote control capability",
        "Multiple frequency scanning"
      ],
      specifications: [
        { name: "Frequency Range", value: "1.6-30 MHz" },
        { name: "Output Power", value: "150W PEP" },
        { name: "Operating Modes", value: "AM/SSB/DSC" },
        { name: "Power Supply", value: "24V DC" }
      ]
    },
    {
      id: 4,
      name: "Inmarsat-C Terminal",
      description: "Reliable satellite communication system for global coverage and GMDSS compliance",
      image: inmarsat,
      features: [
        "Global coverage",
        "Distress alerting",
        "Email and message transmission",
        "Enhanced Group Calling (EGC)"
      ],
      specifications: [
        { name: "Frequency Band", value: "L-Band" },
        { name: "Message Capacity", value: "32 KB storage" },
        { name: "Position Update", value: "Automatic" },
        { name: "Certification", value: "GMDSS approved" }
      ]
    },
    {
      id: 5,
      name: "Iridium System",
      description: "Global satellite phone and data communication system with pole-to-pole coverage",
      image: iridium,
      features: [
        "True global coverage",
        "Voice and data services",
        "Emergency SOS button",
        "Weather resistant design"
      ],
      specifications: [
        { name: "Coverage", value: "Global (including poles)" },
        { name: "Voice Quality", value: "Digital clear voice" },
        { name: "Data Speed", value: "Up to 2.4 kbps" },
        { name: "Battery Life", value: "Up to 30 hours standby" }
      ]
    }
];

export default comProducts;
